import React from 'react';
import { useSelector } from 'react-redux';
import { hasPermission } from '../utils/common';

const ProtectedComponent = ({ requiredPermission, children }) => {
  const permissionMap = useSelector(
    (state) => state.loginReducer?.permissionsMap,
  );

  if (!hasPermission(permissionMap, requiredPermission)) {
    return null; // or return a message like <div>Access Denied</div>
  }

  return <>{children}</>;
};

export default ProtectedComponent;
